import { createSlice } from "@reduxjs/toolkit";

const initialSettings = {
  graphMetricField: "clientBudgetDelivered",
  budgetTypeField: "clientBudgetDelivered",
  graphType: "bar",
  graphSortBy: "metric",
  visibleSettings: true,
};

// INITIAL STATE
const initialState = {
  lineItems: [],
};


const lineItemPerformanceSettingsSlice = createSlice({
  name: "lineItemPerformanceSettings",
  initialState,
  reducers: {
    setGraphMetricField: (state, action) => {
      state.lineItems = state.lineItems.map((lineItem) => {
        if (lineItem.id === action.payload.id) {
          const updatedSettings = {
            ...lineItem.performanceSettings,
            graphMetricField: action.payload.graphMetricField,
          };
          return { ...lineItem, performanceSettings: updatedSettings };
        } else {
          return lineItem;
        }
      });
    },
    setBudgetTypeField: (state, action) => {
      state.lineItems = state.lineItems.map((lineItem) => {
        if (lineItem.id === action.payload.id) {
          const updatedSettings = {
            ...lineItem.performanceSettings,
            budgetTypeField: action.payload.budgetTypeField,
          };
          return { ...lineItem, performanceSettings: updatedSettings };
        } else {
          return lineItem;
        }
      });
    },
    setGraphType: (state, action) => {
      state.lineItems = state.lineItems.map((lineItem) => {
        if (lineItem.id === action.payload.id) {
          const updatedSettings = {
            ...lineItem.performanceSettings,
            graphType: action.payload.graphType,
          };
          return { ...lineItem, performanceSettings: updatedSettings };
        } else {
          return lineItem;
        }
      });
    },
    setGraphSortBy: (state, action) => {
      state.lineItems = state.lineItems.map((lineItem) => {
        if (lineItem.id === action.payload.id) {
          const updatedSettings = {
            ...lineItem.performanceSettings,
            graphSortBy: action.payload.graphSortBy,
          };
          return { ...lineItem, performanceSettings: updatedSettings };
        } else {
          return lineItem;
        }
      });
    },
    setVisibleSettings: (state, action) => {
      state.lineItems = state.lineItems.map((lineItem) => {
        if (lineItem.id === action.payload.id) {
          const updatedSettings = {
            ...lineItem.performanceSettings,
            visibleSettings: action.payload.visibleSettings,
          };
          return { ...lineItem, performanceSettings: updatedSettings };
        } else {
          return lineItem;
        }
      });
    },
    initPerformanceSettingsSet: (state, action) => {
      if (!state.lineItems.find((lineItem) => lineItem.id === action.payload.id)) {
        state.lineItems.push({
          id: action.payload.id,
          performanceSettings: initialSettings,
        });
      }
    },
  },
});

export const { setGraphMetricField, setBudgetTypeField, setGraphType, setGraphSortBy, setVisibleSettings, initPerformanceSettingsSet } =
  lineItemPerformanceSettingsSlice.actions;
export const lineItemPerformanceSettingsReducer =
  lineItemPerformanceSettingsSlice.reducer;
